import type { IToggle } from '@unleash/nextjs';

import { FeatureFlagConstants } from './constants/utilConstants';
import { getFeatureFlagConfig } from './RemoteConfig';

export const getLapserConfig = (
  remoteConfig: IToggle[],
  page?: string | null
): { enabled: boolean; position?: number } => {
  const { enabled, payload } = getFeatureFlagConfig(
    remoteConfig ?? [],
    FeatureFlagConstants.FEATURE_LAPSER_BANNER
  );
  if (!page) {
    return { enabled };
  }
  const pageConfig = payload?.pages?.[page];
  return {
    position: pageConfig?.position,
    enabled: enabled && !!pageConfig?.enabled
  };
};
